export default "__VITE_ASSET__woFSxnLO__"